import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getUGCByType, getUGCListByUsers, getUGCByBibs } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'tagsTransactions'], Immutable.Map());

export const getTags = getUGCByType('tags');
export const getTagsByUsers = getUGCListByUsers('tags');
export const getTagsByBibs = getUGCByBibs('tags');

export const getTagsTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getTags,
  getTagsByUsers,
  getTagsByBibs,
  getTagsTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/TagsSelector.js